
import React from "react";
import Navbar from "@/components/layout/Navbar";
import ConsultationInterface from "@/components/recording/ConsultationInterface";
import { Toaster } from "@/components/ui/toaster";

const Consultation = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="mobile-container w-full py-4 sm:py-6">
        <Navbar />
        <main className="flex-1 overflow-y-auto mt-4 sm:mt-6">
          <div className="max-w-6xl mx-auto">
            <ConsultationInterface />
          </div>
        </main>
      </div>
      <Toaster />
    </div>
  );
};

export default Consultation;
